export default __webpack_public_path__ + "static/media/megaphone.ca8069c2.svg";